const updates = [
  { date: '08-01', tag: '新剧上线', text: '悬疑大剧《无声证词》全集上线，高能反转口碑炸裂' },
  { date: '07-31', tag: '电影更新', text: '国产科幻巨制《星际迷途》4K HDR版本已收录' },
  { date: '07-31', tag: '综艺同步', text: '王牌综艺最新一期已更新，豪华嘉宾阵容引爆笑点' },
  { date: '07-30', tag: '片库扩充', text: '经典港片专场新收录50部，一键重温黄金年代' },
  { date: '07-29', tag: '系统优化', text: '播放器全面升级，新增智能画质调节与记忆续播功能' },
  { date: '07-28', tag: '电影更新', text: '暑期档动画《梦境奇旅》高清版上线，亲子观影首选' },
  { date: '07-27', tag: '新剧上线', text: '高甜韩剧全集上线，周末一口气追完不过瘾' },
  { date: '07-26', tag: '热门推荐', text: '爱情文艺片《那年星空下》全网首发，评分一路走高' },
  { date: '07-25', tag: '专题上线', text: '悬疑烧脑专题正式上线，精选20部高能反转佳作' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-400 mb-3">UPDATES</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">最新动态</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">成全影院近期内容更新与平台动态一览</p>
          </div>

          <div className="max-w-[700px] mx-auto">
            {updates.map((u, i) => (
              <div key={i} className="relative flex items-start gap-4 pb-6 pl-8 border-l-2 border-background-200/50 last:border-l-0 last:pb-0">
                <div className="absolute left-0 top-0 -translate-x-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">{u.date}</span>
                    <span className="text-xs px-2 py-0.5 rounded bg-accent-500/10 text-accent-400 font-medium whitespace-nowrap">{u.tag}</span>
                  </div>
                  <p className="text-sm text-foreground-300 leading-relaxed">{u.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}